document.addEventListener("DOMContentLoaded", function () {
    const reviewSlider = $(".reviews-list").slick({
      rows: 2,
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            rows: 2,
            slidesPerRow: 1,
            centerMode: true,
          },
        },
      ],
    });
  
    $(".reviews-slider-button.button--next").on("click", function () {
      reviewSlider.slick("slickNext");
    });
  
    $(".reviews-slider-button.button--prev").on("click", function () {
      reviewSlider.slick("slickPrev");
    });

    const reviewSliderCat = $(".reviews-list-cat").slick({
        rows: 1,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              rows: 1,
              slidesPerRow: 1,
              centerMode: true,
            },
          },
        ],
      });

    $(".reviews-slider-button.button--next").on("click", function () {
      reviewSliderCat.slick("slickNext");
    });
  
    $(".reviews-slider-button.button--prev").on("click", function () {
      reviewSliderCat.slick("slickPrev");
    });
  });
